module.exports = __webpack_public_path__ + "img/power_cabinet.e39bdf6a.png";